import { DateRangeOption as Option } from '../../graphql/schema';

const labels = {
  [Option.AllTime]: 'All',
  [Option.PastFiveYears]: '5Y',
  [Option.PastThreeYears]: '3Y',
  [Option.PastTwoYears]: '2Y',
  [Option.PastYear]: '1Y',
  [Option.YearToDate]: 'YTD',
  [Option.PastThreeMonths]: '3M',
  [Option.PastMonth]: '1M',
  [Option.PastWeek]: '1W',
  [Option.Today]: 'Today',
  [Option.Custom]: 'Custom',
};

const standard = [
  Option.AllTime,
  Option.PastFiveYears,
  Option.PastThreeYears,
  Option.PastYear,
  Option.YearToDate,
  Option.PastThreeMonths,
  Option.PastMonth,
];
const beforeLastYear = [Option.PastFiveYears, Option.PastThreeYears, Option.PastTwoYears];

const throughPastYear = standard.filter(o => !beforeLastYear.includes(o));

export const DateRangeOptions = {
  labels,
  standard,
  throughPastYear,
};
